







import { Vue, Component, Prop } from 'vue-property-decorator'
import { ProductInfoListMap } from '@/types/newPersion'
@Component
export default class ProductInfoOpt extends Vue {
    @Prop() productMap!: ProductInfoListMap
}
